export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [9,[2]],
		"/(app)/admin": [10,[2,3]],
		"/(app)/admin/analytics": [11,[2,3]],
		"/(app)/admin/analytics/[tab]": [12,[2,3]],
		"/(app)/admin/evaluations": [13,[2,3]],
		"/(app)/admin/evaluations/[tab]": [14,[2,3]],
		"/(app)/admin/functions": [15,[2,3]],
		"/(app)/admin/functions/create": [16,[2,3]],
		"/(app)/admin/functions/edit": [17,[2,3]],
		"/(app)/admin/settings": [18,[2,3]],
		"/(app)/admin/settings/[tab]": [19,[2,3]],
		"/(app)/admin/users": [20,[2,3]],
		"/(app)/admin/users/[tab]": [21,[2,3]],
		"/auth": [54],
		"/(app)/automations": [22,[2]],
		"/(app)/automations/[id]": [23,[2]],
		"/(app)/calendar": [25,[2]],
		"/(app)/channels/[id]": [26,[2]],
		"/(app)/c/[id]": [24,[2]],
		"/error": [55],
		"/(app)/home": [27,[2,4]],
		"/(app)/notes": [28,[2,5]],
		"/(app)/notes/new": [30,[2,5]],
		"/(app)/notes/[id]": [29,[2,5]],
		"/(app)/playground": [31,[2,6]],
		"/(app)/playground/completions": [32,[2,6]],
		"/(app)/playground/images": [33,[2,6]],
		"/(app)/projects": [34,[2,7]],
		"/(app)/projects/[id]": [35,[2,7]],
		"/s/[id]": [56],
		"/watch": [57],
		"/(app)/workspace": [36,[2,8]],
		"/(app)/workspace/functions/create": [37,[2,8]],
		"/(app)/workspace/knowledge": [38,[2,8]],
		"/(app)/workspace/knowledge/create": [40,[2,8]],
		"/(app)/workspace/knowledge/[id]": [39,[2,8]],
		"/(app)/workspace/models": [41,[2,8]],
		"/(app)/workspace/models/create": [42,[2,8]],
		"/(app)/workspace/models/edit": [43,[2,8]],
		"/(app)/workspace/office": [44,[2,8]],
		"/(app)/workspace/prompts": [45,[2,8]],
		"/(app)/workspace/prompts/create": [47,[2,8]],
		"/(app)/workspace/prompts/[id]": [46,[2,8]],
		"/(app)/workspace/skills": [48,[2,8]],
		"/(app)/workspace/skills/create": [49,[2,8]],
		"/(app)/workspace/skills/edit": [50,[2,8]],
		"/(app)/workspace/tools": [51,[2,8]],
		"/(app)/workspace/tools/create": [52,[2,8]],
		"/(app)/workspace/tools/edit": [53,[2,8]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';